module.exports = __webpack_public_path__ + "static/media/Amah_desktop_article_7.4db003f5.jpg";